import cls from "classnames";
import BottomSheetModalHOC from "@qoohoo/common/library/modals/BottomSheetModalHOC";

const SubscribeModalWrapper = ({
  channelDetails,
  closeModal,
  children,
  hideTitleImage = false,
  isWhiteTheme = false,
}) => {
  const hasChannelImage = !!channelDetails.center_image?.url;
  const showTitleImage = !hideTitleImage && hasChannelImage;

  return (
    <BottomSheetModalHOC>
      <div className={cls("sm:inline-block sm:align-middle sm:h-full", {"dark": isWhiteTheme})}>
        <div className="relative inline-flex items-end justify-center w-full h-full sm:items-center font-nunito sm:py-14">
          <div
            className={cls(
              "relative bg-modal-bg shadow-xl rounded-t-2xl sm:rounded-2xl max-w-full w-full sm:max-w-[360px] sm:w-[360px] dark:bg-white"
            )}
          >
            {showTitleImage && (
              <div className={cls(
                "absolute -top-12 right-0 left-0 mx-auto flex items-center justify-center w-24 h-24 rounded-[20px]",
                isWhiteTheme ? "bg-modal-[white]" : "bg-modal-bg"
              )}>
              <img
                  className="w-[88px] h-[88px] object-cover object-center rounded-[20px] z-10 select-none"
                  src={channelDetails.center_image.url}
                  alt={channelDetails.name}
                />
              </div>
            )}
            {
              isWhiteTheme?
              <img
                src="/assets/icons/close-icon-dark.svg"
                lt="close button"
                onClick={closeModal}
                className="absolute z-10 cursor-pointer select-none right-4 top-4"
              />
              :
              <img
                src="/assets/icons/close-icon.svg"
                lt="close button"
                onClick={closeModal}
                className="absolute z-10 cursor-pointer select-none right-4 top-4"
              />
            }
            <div
              className={cls(
                "w-full",
                showTitleImage ? "px-6 pb-10 pt-[70px]" : "px-5 py-8"
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </BottomSheetModalHOC>
  );
};

export default SubscribeModalWrapper;
